import { Component } from "react";
import {set_datapage, SetLanguage, getLanguage} from 'redux/actions/DataPageAction'
import { connect } from "react-redux";
import { createHChart } from "layouts/mainsection/components/CHighchartToolsTraffic";


class FITRazonComActoIlegTra extends Component {
 
  componentDidMount () {
  
    
  }
  render () {
   //[{year: 2002, value: 10.5}]
    
    return this.props.data.series.length > 0 ?  
    <>
    { createHChart('chartFITRazonComActoIlegTra',
              {
                  
                  chart: { type: 'column' },
                  title: {
                      text: this.props.title
                  },
                  xAxis: { 
                    title: { 
                      text: 'Especies',
                    enabled: false
                    }, 
                    // width: 100,
                    //tickWidth: 100,
                    categories:  this.props.data.categorias
                  },
                  yAxis: {
                    
                      min: 0,
                      title: {
                          text: 'Cantidad',
                          enabled: false
                      }
                  },
                  // legend: { enabled: false },
                  plotOptions: {
                      series: {
                          // stacking: 'normal',
                          //pointWidth: 30
                      }
                  },
                  series: this.props.data.series
              //     series: [{
              //       type: 'column', name: 'Cantidad', 
              //       colorByPoint: true, 
              //       data: this.props.data.map(item => parseInt(item.value)),
              //       dataLabels: {
              //           enabled: true,
              //             //rotation: -90,
              //             //color: '#FFFFFF',
              //             //align: 'right',
              //             format: '{point.y:.1f}', // one decimal
              //             //y: 10, // 10 pixels down from the top
              //             //style: {
              // //                fontSize: '13px',
              // //                fontFamily: 'Verdana, sans-serif'
              //   //          }
              //         }
              //   }]
              }
            ) }
            
          <div style={{fontSize: '0.9em'}}>

            <div className="has-text-centered" style={{fontSize: '0.9em'}}>
              <p className="px-6" style={{
              color: '#000',
              fontSize: '1.1em',
              
              fill: '#000'
              }}><i>{ this.props.description }</i></p>
            </div>
            </div>
            </>
            : null
    
  }
}

export default connect(getLanguage, {set_datapage, SetLanguage})(FITRazonComActoIlegTra)